import store from '@/store'
import { AES } from './encode'
export const user = {
    getRegions: (cityId) => {
        let ids = new Array()
        store.state.user.userInfo.permissions.regions.forEach(r => {
            if ((cityId && r.parentId == cityId) || !cityId) {
                ids.push(r.id)
            }
        });
        return ids
        // let encoded = AES.encode({
        //     data: { data: JSON.stringify(ids) },
        //     param: ['data'],
        //     key: '1673560782534185'
        // })
        // let encodeIds = encoded.data
        // return encodeIds
    },
    getCities: () => {
        let ids = new Array()
        store.state.user.userInfo.permissions.cities.forEach(r => {
            ids.push(r.id)
        });
        return ids
        // let encoded = AES.encode({
        //     data: { data: JSON.stringify(ids) },
        //     param: ['data'],
        //     key: '1673560782534185'
        // })
        // let encodeIds = encoded.data
        // return encodeIds
    }
}